import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "styled-components"

export const QuoteElement = ({ children }: { children: any }) => {
    
    return (
        <QuoteContainer>
            <div className="header">
                <FontAwesomeIcon className="icon" icon={['fal', 'circle-info']} />
            </div>
            <div className="content">{children}</div>
        </QuoteContainer>
    )
}


const QuoteContainer = styled.blockquote`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 1rem 0;
    background-color: ${props => props.theme.color.sidebar.gray1};
    border: 1px solid ${props => props.theme.color.sidebar.gray3};
    transition: all 0.2s ease;
    border-radius: 8px;
    .header{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        background-color: ${props => props.theme.color.sidebar.gray3};
        border-bottom: 1px solid ${props => props.theme.color.sidebar.gray3};
        padding: 10px;
        color:white;
        border-radius: 8px 8px 0 0;
        .icon{
            margin-right: 10px;
        }
    }
    .content{
        padding: 0px 15px 15px 15px;
    }
`